import { ApiBoardRepository } from './api-repository.js'
import type { BoardRepository } from './repository.js'

export * from './repository.js'
export * from './save-queue.js'
export { ApiBoardRepository } from './api-repository.js'
/**
 * Exported for tests only. It is a stand-in for the HTTP adapter in unit tests, not a way
 * to run the app: there is no in-browser storage mode any more.
 */
export { MemoryBoardRepository } from './memory-repository.js'

/**
 * There is one adapter. Boards live in the database behind the API however the app is
 * started, so nothing the user does can end up in storage that a refresh throws away.
 */
export function createRepository(): BoardRepository {
  return new ApiBoardRepository()
}
